export default __webpack_public_path__ + "static/0143-439c86e20fdc79c7346f57f39d02fe19.png";